<div #outage_chartdiv [id]="'outage__chart_' + country + asset" class="outage-chart"></div>
